export default [
  {
    path: '/:showPanel?',
    name: 'Home',
    component: () => import(
      '../views/home/Home.vue'),
    meta: {
      title: 'Inicio',
      requiresAuthentication: true,
      requiresAuthorization: false,
    },
  },
  {
    path: '/UsuarioDetalleView/:id?',
    name: 'UsuarioDetalleView',
    component: () =>
      import(
        '../views/configuracion/usuarios/UsuarioDetalleView'),
    meta: {
      title: 'Gestión datos usuario',
      requiresAuthentication: true,
      requiresAuthorization: false,
      bread: {
        path: [
          'Inicio',
        ],
      },
    },
  },
];
